// Why.js — “Зачем нужен бот”
import { motion } from 'framer-motion'

const items = [
  {
    emoji: '❤️',
    title: 'Без барьеров',
    text: 'Никаких длинных форм и логинов. У всех уже есть Telegram — контакт оставляют в один тап.',
  },
  {
    emoji: '📸',
    title: 'Фото → сразу гостю',
    text: 'Гость получает свои снимки прямо в чат, а вы — контакт и долгосрочную лояльность.',
  },
  {
    emoji: '💬',
    title: 'Живой канал',
    text: 'Чат на событии: вопросы спикерам, быстрые ответы, доп. материалы — всё в одном месте.',
  },
  {
    emoji: '📈',
    title: 'Маркетинг без боли',
    text: 'Опросы, анонсы, прогрев будущих ивентов. Нативно и с метриками вовлечённости.',
  },
  {
    emoji: '🎯',
    title: 'Лиды мягко',
    text: 'Контакты собираются естественно — без навязчивого спама. Конверсия выше, отток ниже.',
  },
  {
    emoji: '🧩',
    title: 'Под ваши процессы',
    text: 'Квизы, e-регистрация, кастомная логика. Бот настраивается под ваши сценарии.',
  },
]

const container = {
  hidden: { opacity: 1 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.08, delayChildren: 0.05 },
  },
}

const item = {
  hidden: { opacity: 0, y: 18 },
  show: { opacity: 1, y: 0, transition: { duration: 0.4, ease: 'easeOut' } },
}

export default function Why({ className = '' }) {
  return (
    <section aria-labelledby="why-title" className={className}>
      <h2 id="why-title" className="sr-only">
        Зачем нужен бот
      </h2>

      <motion.ul
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: '0px 0px -80px 0px' }}
        className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6"
      >
        {items.map(({ emoji, title, text }, i) => (
          <motion.li
            key={i}
            variants={item}
            className="relative rounded-2xl border border-slate-200/70 bg-gradient-to-br from-white via-white to-sky-50/60 shadow-sm hover:shadow-lg transition-shadow"
            aria-label={`${title}: ${text}`}
          >
            {/* Badge */}
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 w-10 h-10 rounded-full bg-white border border-slate-200 shadow-md grid place-items-center text-base">
              <span aria-hidden="true">{emoji}</span>
            </div>

            {/* Content */}
            <div className="pt-8 pb-4 px-4 sm:px-5">
              <h3 className="font-montserrat font-semibold text-slate-900 text-base sm:text-lg leading-snug text-center">
                {title}
              </h3>
              <p className="mt-2 text-slate-700 text-sm leading-relaxed text-center">
                {text}
              </p>
            </div>
          </motion.li>
        ))}
      </motion.ul>
    </section>
  )
}
